// removed by extract-text-webpack-plugin
module.exports = {"content":"_1fOtHiCtubS8x25_FMtgcE","body":"_3X0nF3yRqEtM9pmC5gc7ai"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/MessageBox/MessageBoxFunctionalLayout.scss
// module id = ./node_modules/wix-style-react/dist/es/src/MessageBox/MessageBoxFunctionalLayout.scss
// module chunks = 0